package com.alpha.showcase.common.ai

internal actual fun scheduleAiBackgroundWork() = Unit
